// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceEvaluationPage-cls1_JGQ","cls2":"ReferenceEvaluationPage-cls2_rnu ReferenceEvaluationPage-cls1_JGQ","fadeInUp":"ReferenceEvaluationPage-fadeInUp_IOg"};